import { render, staticRenderFns } from "./LandingPageEditorCoverEditor.vue?vue&type=template&id=506e6d1f"
import script from "./LandingPageEditorCoverEditor.vue?vue&type=script&lang=js"
export * from "./LandingPageEditorCoverEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports